import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {LanguageState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class LanguageQuery extends QueryEntity<LanguageState> {

  constructor(protected store: Store) {
    super(store);
  }

}
